module.exports = __webpack_public_path__ + "static/project-van-wind-naar-watt-a3899e2cfb75795843099fa9cf87b751.jpg";